import React from "react"
import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import { get } from "lodash"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"

type Props = {
  updateStatistics: Function
  division: string
}

//API
export const statisticsApiCall = async (props: Props) => {
  const loadResistId = uuid()
  store.dispatch(pageLoadRegist(loadResistId, true))
  const statisticsData:
    | APIResponse.Res
    | [] = await APIs.Tool.DivisionStatistics({
    Division: props.division,
  })
  const resultList = get(statisticsData, "ResultList")
  props.updateStatistics(resultList)
  store.dispatch(pageLoadRegist(loadResistId, false))
}
